import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import classNames from 'classnames';
import { getTsMinutes } from 'screens/Live/LiveHelpers';
import Style from './CurrentTimer.module.scss';

class CurrentTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minutes: getTsMinutes(),
    };
  }

  componentDidMount() {
    const { setInterval } = this.props;

    setInterval(() => {
      const { minutes } = this.state;
      const { totalMinutes, ended } = this.props;
      const newMinutes = getTsMinutes();
      const minutesElapsed = this.getMinutesElapsed(newMinutes);

      if (minutes !== newMinutes) {
        if (ended && minutesElapsed >= totalMinutes) {
          ended();
        }
        this.setState({ minutes: newMinutes });
      }
    }, 1000);
  }

  getMinutesElapsed(minutes) {
    const { startingTs } = this.props;
    return minutes - Math.floor(startingTs / 60);
  }

  render() {
    const { totalMinutes, openRow, totalRows } = this.props;
    const { minutes } = this.state;
    const minutesElapsed = this.getMinutesElapsed(minutes);
    const currentPosition = Math.floor(100 * (minutesElapsed / totalMinutes));
    const leftStyle = { left: `${currentPosition}%` };
    const splitStyleTop = { ...leftStyle, height: `calc(${openRow + 1} * 5.625rem - 14px)` };
    const splitStyleBottom = {
      ...leftStyle,
      height: `calc(${totalRows - openRow - 1} * 5.625rem - 20px)`,
      bottom: 0,
    };
    const timerClasses = [Style.container];
    const timerContainerClass = classNames(timerClasses);
    const splitTimer = (
      <>
        <div className={Style.splitTimer} style={splitStyleTop} />
        <div className={Style.splitTimer} style={splitStyleBottom} />
      </>
    );
    const fullTimer = <div style={leftStyle} className={Style.currentTimer} />;

    return (
      <div className={timerContainerClass}>
        <div style={leftStyle} className={Style.currentTimerArrow} />
        {openRow !== null ? splitTimer : fullTimer}
      </div>
    );
  }
}

CurrentTimer.defaultProps = {
  ended: () => {},
  openRow: null,
  totalRows: null,
};

CurrentTimer.propTypes = {
  ended: PropTypes.func,
  openRow: PropTypes.number,
  setInterval: PropTypes.func.isRequired,
  startingTs: PropTypes.number.isRequired,
  totalMinutes: PropTypes.number.isRequired,
  totalRows: PropTypes.number,
};

export default ReactTimeout(CurrentTimer);
